import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  requests: null,
  loading: false,
  error: null,
  request: null
};

const updateRequests = (requests, newRequest) => {
  return requests.map((item, index) => {
    if (item.id !== newRequest.id) {
      return item;
    }
    return { ...item, ...newRequest };
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_REQUESTS_BEGIN:
      return updateObject(state, { redirectTo: null, loading: true, error: null, requests: []});
    case actionTypes.FETCH_REQUEST_BEGIN:
    case actionTypes.UPDATE_REQUEST_BEGIN:
    case actionTypes.REMOVE_REQUEST_BEGIN:
    case actionTypes.ADD_REQUEST_BEGIN:
    case actionTypes.ADD_REQUEST_MESSAGE_BEGIN:
      return updateObject(state, { redirectTo: null, loading: true, error: null });
    case actionTypes.FETCH_REQUESTS_FAILED:
      return updateObject(state, {
        loading: false,
        error: action.payload.error,
        requests: null
      });
    case actionTypes.FETCH_REQUEST_FAILED:
      return updateObject(state, {
        loading: false,
        error: action.payload.error,
        request: null
      });
    case actionTypes.UPDATE_REQUEST_FAILED:
    case actionTypes.ADD_REQUEST_FAILED:
    case actionTypes.ADD_REQUEST_MESSAGE_FAILED:
    case actionTypes.REMOVE_REQUEST_FAILED:
      return updateObject(state, {
        loading: false,
        error: action.payload.error
      });

    case actionTypes.FETCH_REQUESTS_SUCCESS:
      return updateObject(state, {
        loading: false,
        requests: action.payload.requests
      });
    case actionTypes.FETCH_REQUEST_SUCCESS:
      return updateObject(state, {
        loading: false,
        request: action.payload.request
      });
    case actionTypes.UPDATE_REQUEST_SUCCESS:
      var updatedRequests = state.requests.map((item, index) => {
        if (item.id !== action.payload.request.id) {
          return item;
        }
        return { ...item, ...action.payload.request };
      });
      return updateObject(state, {
        loading: false,
        requests: updatedRequests,
        request: action.payload.request
      });
    case actionTypes.ADD_REQUEST_SUCCESS:
      return updateObject(state, {
        requests: [
          ...state.requests.slice(0, 0),
          action.payload.request,
          ...state.requests.slice(0)
        ],
        request: action.payload.request,
        loading: false,
        error: null
      });
    case actionTypes.ADD_REQUEST_MESSAGE_SUCCESS:
      return updateObject(state, {
        loading: false,
        requests: this.updateRequests(state.requests, action.payload.request),
        request: action.payload.request
      });

    case actionTypes.REMOVE_REQUEST_SUCCESS:
      let index = state.requests.findIndex(
        x => x.id === action.payload.request.id
      );
      return updateObject(state, {
        requests: [
          ...state.requests.slice(0, index),
          ...state.requests.slice(index + 1)
        ],
        request: action.payload.request,
        loading: false,
        error: null
      });
    case actionTypes.REDIRECT:
      return { redirectTo: action.payload };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/request.js